import api from "@/router/api";

export default {
  async getFrequencia(encontroId) {
    const response = await api.get("/frequecia", {
      params: { encontroId },
    });
    return response.data;
  },

  async getHistoricoFrequenciaAtividade(atividadeId) {
    const response = await api.get("/frequecia/historico", {
      params: { atividadeId },
    });
    return response.data;
  },

  async postFrequencia(frequencia, encontroId) {
    const response = await api.post("/frequecia", frequencia, {
      params: { encontroId },
    });
    return response.data;
  },

  async postFrequenciaMuitas(frequencias, encontroId) {
    const response = await api.post("/frequecia/adiciona-muitas", frequencias, {
      params: { encontroId },
    });
    return response.data;
  },

  async deleteFrequencia(encontroId, frequencia) {
    const response = await api.delete("/frequecia/delete", {
      data: frequencia,
      params: { encontroId },
    });
    return response.data;
  },

  async baixarMapaDeFrequencia(atividadeId) {
    const response = await api.get("/frequecia/mapa", {
      params: { atividadeId },
      responseType: "blob",
    });
    return response.data;
  },
};
